import"../../../chunk-LO54M23N.mjs";class o extends Error{constructor(r){super(`Invalid token ${r!=null?r:""}`)}}export{o as InvalidTokenError};
//# sourceMappingURL=invalid-token.error.mjs.map